document.addEventListener('DOMContentLoaded', () => {
  const archivMegaMenu = document.querySelector('.mega-menu-column-archiv');
  if (!archivMegaMenu) return;

  // --- Configuration ---
  const storefrontAccessToken = 'f1d12daaf6396326a69467289ab0e3cf';
  const storefrontUrl = 'https://bsxdev.myshopify.com/api/2024-04/graphql.json';
  const collectionHandle = 'archiv';
  const brandsToDisplay = ['Dior', 'Givenchy', 'Swarovski', 'Monet', 'Trifari'];
  // -------------------

  let productsByBrand = {};
  let hasFetched = false;
  const locale = archivMegaMenu.dataset.locale;

  const GQL_QUERY = `
    query getArchivProducts($handle: String!, $language: LanguageCode!) @inContext(language: $language) {
      collection(handle: $handle) {
        products(first: 250) {
          nodes {
            title
            onlineStoreUrl
            media(first: 2) {
              nodes {
                ... on MediaImage {
                  image {
                    url(transform: {maxWidth: 400, maxHeight: 400, crop: CENTER})
                    altText
                  }
                }
              }
            }
            brand: metafield(namespace: "my_fields", key: "marke") {
              value
            }
            wert_max: metafield(namespace: "my_fields", key: "wert_max") {
              value
            }
          }
        }
      }
    }
  `;

  const fetchArchivProducts = async () => {
    if (hasFetched) return;
    hasFetched = true;

    try {
      const response = await fetch(storefrontUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
          query: GQL_QUERY,
          variables: { handle: collectionHandle, language: locale.toUpperCase() },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const jsonResponse = await response.json();
      
      if (jsonResponse.errors) {
        console.error('GraphQL Errors:', jsonResponse.errors);
        return;
      }

      const allProducts = jsonResponse.data.collection.products.nodes;

      const filteredProducts = allProducts.filter(p => {
        const wertMax = p.wert_max ? parseFloat(p.wert_max.value) : 0;
        const brand = p.brand ? p.brand.value : null;
        return wertMax >= 90 && brand && brandsToDisplay.includes(brand);
      });

      brandsToDisplay.forEach(brand => {
        productsByBrand[brand] = filteredProducts.filter(p => p.brand.value === brand);
      });

      renderProducts();

    } catch (error) {
      console.error('Error fetching archiv products via Storefront API:', error);
    }
  };

  const renderProducts = () => {
    const grid = archivMegaMenu.querySelector('.archiv-preview-grid');
    if (!grid) return;

    // Remove loading placeholder
    const placeholder = grid.querySelector('.archiv-loading-placeholder');
    if (placeholder) {
      placeholder.remove();
    }

    grid.innerHTML = '';

    brandsToDisplay.forEach(brand => {
      const brandProducts = productsByBrand[brand];
      if (brandProducts && brandProducts.length > 0) {
        const randomIndex = Math.floor(Math.random() * brandProducts.length);
        const product = brandProducts[randomIndex];

        const mediaNodes = product.media.nodes;
        const firstImage = mediaNodes[0] && mediaNodes[0].image ? mediaNodes[0].image : null;
        const secondImage = mediaNodes[1] && mediaNodes[1].image ? mediaNodes[1].image : null;

        if (!firstImage) {
          return;
        }

        const secondImageTag = secondImage
          ? `<img class="archiv-secondary-image" src="${secondImage.url}" alt="${secondImage.altText || product.title}" loading="lazy" decoding="async" width="400" height="400">`
          : '';

        const productHTML = `
          <div class="archiv-preview-item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--product card--standard" style="--ratio-percent: 100%;">
                <div class="card__inner ratio" style="--ratio-percent: 100%;">
                  <div class="card__media">
                    <a href="${product.onlineStoreUrl}" class="card__media-link">
                      <div class="media media--hover-effect">
                        <img
                          src="${firstImage.url}"
                          alt="${firstImage.altText || product.title}"
                          loading="eager"
                          fetchpriority="high"
                          decoding="async"
                          width="400"
                          height="400"
                        >
                        ${secondImageTag}
                      </div>
                    </a>
                  </div>
                  <div class="card__badge bottom left">
                    <span class="badge badge--bottom-left archiv-badge color-accent-2" style="color: black !important;">
                      Archiv
                    </span>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="${product.onlineStoreUrl}" class="full-unstyled-link">${product.title}</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
        grid.insertAdjacentHTML('beforeend', productHTML);

        // Removed spinner logic
      }
    });
  };

  // Find the archiv menu item by looking for the text content
  const menuItems = document.querySelectorAll('.menu-item-has-children');
  let archivMenuItem = null;
  
  menuItems.forEach(item => {
    const link = item.querySelector('a');
    if (link && link.textContent.includes('Archiv')) {
      archivMenuItem = item;
    }
  });
  
  if (archivMenuItem) {
    archivMenuItem.addEventListener('mouseenter', fetchArchivProducts, { once: true });
    archivMenuItem.addEventListener('focusin', fetchArchivProducts, { once: true });
  } else {
    console.error('[Archiv Megamenu] Could not find the archiv menu item.');
  }

  // --- Early warming: prefetch on first menu interaction or idle ---
  const canPrefetch = () => {
    try {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!conn) return true;
      const slow = ['slow-2g', '2g'];
      if (slow.includes(conn.effectiveType)) return false;
      if (conn.saveData) return false;
      return true;
    } catch { return true; }
  };

  const menuEl = document.querySelector('.menu');
  const menuMainEl = document.querySelector('.menu-main');

  if (canPrefetch()) {
    // First hover/focus anywhere in the menu warms Archiv
    if (menuEl) {
      menuEl.addEventListener('mouseenter', fetchArchivProducts, { once: true });
      menuEl.addEventListener('focusin', fetchArchivProducts, { once: true });
    }
    if (menuMainEl) {
      menuMainEl.addEventListener('pointerenter', fetchArchivProducts, { once: true });
    }

    // Idle-time fallback: warm if user never opens the menu
    const idlePrefetch = () => fetchArchivProducts();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(idlePrefetch, { timeout: 4000 });
    } else {
      setTimeout(idlePrefetch, 3000);
    }
  }
});